import React from 'react';
import classNames from 'classnames';
import './style.scss';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import { SellerCardProps } from './types';
import StatsDesc from './StatsDesc';
import { ProSubcategories } from './ProSubcategories/ProSubcategories';
import { ExperientialProfileInfo } from './ProfileInfo/ProfileInfoProRebranding/ExperientialProfileInfo';

/** Below the fold seller card */
export const SellerCard: React.FC<SellerCardProps> = (props) => {
  let description = props.seller.description;
  let oneLiner = props.seller.oneLinerTitle;
  if (props.ugc) {
    const { seller = { description: '', oneLiner: '' } } = getCurrentContent({ ugc: props.ugc }) || {};
    description = seller.description;
    oneLiner = seller.oneLiner;
  }

  const { notableClients, proSubCategories, seller, recentDelivery } = props;

  const { isPro, responseTime, user } = seller;

  const { countryCode } = user?.address || '';

  const profilePhoto = seller?.user?.profileImage?.previewUrl?.url;

  const sellerName = user?.name || '';

  const hasProfilePhoto = !!profilePhoto;

  const showPro = isPro && proSubCategories && proSubCategories.length > 0;

  return (
    <div className="below-the-fold-experiential-seller-card-order">
      <div className={classNames('seller-card', { pro: isPro })}>
        <ExperientialProfileInfo
          oneLiner={oneLiner || ''}
          ratingsCount={seller?.rating?.count || 0}
          rating={seller?.rating?.score || 0}
          hasProfilePhoto={hasProfilePhoto}
          profilePhoto={profilePhoto || ''}
        />
        <ProSubcategories proSubcategories={proSubCategories} isPro={!!isPro} />
        <StatsDesc
          description={description || ''}
          recentDelivery={recentDelivery}
          countryCode={countryCode || ''}
          memberSince={user?.joinedAt || 0}
          responseTime={responseTime?.inHours}
          profilePhoto={profilePhoto || ''}
          sellerName={sellerName || ''}
          notableClients={notableClients}
          isPro={!!showPro}
        />
      </div>
    </div>
  );
};
